import type { PrefecturesResponse } from 'features/prefecture/types/prefecture'

export const findPrefectureIdBySlug = (
  prefectureAreas: PrefecturesResponse | null | undefined,
  slug?: string
): number | undefined => {
  if (!prefectureAreas?.length || !slug) return undefined

  for (const area of prefectureAreas) {
    const prefecture = area.prefectures.find((item) => item.slug === slug)
    if (prefecture) return prefecture.id
  }

  return undefined
}
